import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { Row, Col, Table, Button } from "react-bootstrap";
import {
  SET_DAILY_TASKS_PAGINATION,
  createDailyTask,
  fetchDailyTasks,
  resetDailyTasks,
} from "../../store/actions/timesheet/taskActions";
import PageTitle from "../../common/PageTitle";
import moment from "moment";
import ListPagination from "../../common/ListPagination";

class DailyTasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCurrentDate: false,
    };
  }
  componentDidMount() {
    this.props.fetchDailyTasks();
  }

  handleCreate = async () => {
    const id = await this.props.createDailyTask();
    this.props.history.push(`/dailytasks/view?id=${id}`);
  };

  renderDailyTasks = () => {
    let dailyTasks = this.props.dailyTasks.dailyTasks;
    let dailyTaskList = "";

    if (dailyTasks) {
      //if the user tries to search and no matches the filter
      if (!dailyTasks.length) {
        dailyTasks = null;
      } else {
        let min = this.props.dailyTasks.min;
        let max = this.props.dailyTasks.max;

        //don't paginate if there's filter
        if (this.props.dailyTasks.dailyTasks) {
          dailyTasks = dailyTasks.slice(min - 1, max);
        }
      }
    }

    if (dailyTasks) {
      dailyTaskList = dailyTasks.length ? (
        dailyTasks.map((dailyTask, key) => {
          const status = JSON.parse(dailyTask.status);
          // if (dailyTask.date === this.state.currentDate) {
          //   this.state.isCurrentDate = true;
          // }
          return (
            <tr key={key}>
              <td className="align-center" colSpan={3}>
                <Link
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.resetDailyTasks();
                    this.props.history.push(
                      `/dailytasks/view?id=${dailyTask.id}`
                    );
                  }}
                >
                  <strong>{dailyTask.request_number}</strong>
                </Link>
              </td>
              <td className="align-center" colSpan={3}>
                <span>{dailyTask.date}</span>
              </td>
              <td colSpan={5}>
                <tr className=" d-flex justify-content-center">
                  {status !== null ? (
                    <>
                      <strong style={{ color: "#ffc107" }}>
                        {`Pending: ${status.pending};`} &nbsp;
                      </strong>
                      <strong style={{ color: "#6c757d" }}>
                        {` On hold: ${status.on_hold};`} &nbsp;
                      </strong>
                      <strong style={{ color: "#17a2b8" }}>
                        {`On Going: ${status.on_going};`} &nbsp;
                      </strong>
                      <strong style={{ color: "#28a745" }}>
                        {`Completed: ${status.completed};`} &nbsp;
                      </strong>
                      <strong style={{ color: "#CC3333" }}>
                        {`Failed: ${status.failed};`} &nbsp;
                      </strong>
                    </>
                  ) : (
                    <strong>Not Started</strong>
                  )}
                </tr>
              </td>
              <td className="align-center" colSpan={1}>
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.resetDailyTasks();
                    this.props.history.push(
                      `/dailytasks/view?id=${dailyTask.id}`
                    );
                  }}
                >
                  View
                </Button>
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={4}>
            <i>Loading...</i>
          </td>
        </tr>
      );
    } else {
      dailyTaskList = (
        <tr>
          <td colSpan={4}>
            <p className="text-danger">No Tasks found.</p>
          </td>
        </tr>
      );
    }

    return (
      <Table hover>
        <thead className="align-center">
          <tr>
            <th colSpan={3}>Task ID</th>
            <th colSpan={3}>Date</th>
            <th colSpan={5}>Status</th>
            <th colSpan={1}>Status</th>
          </tr>
        </thead>
        <tbody className="h-auto">{dailyTaskList} </tbody>
      </Table>
    );
  };

  render() {
    const currentDate = moment().format("YYYY-MM-DD");
    let dailyTasks = this.props.dailyTasks.dailyTasks;
    console.log(dailyTasks);
    const listPagination = dailyTasks ? (
      <ListPagination
        dispatchType={SET_DAILY_TASKS_PAGINATION}
        data={this.props.dailyTasks.dailyTasks}
        min={this.props.dailyTasks.min}
        max={this.props.dailyTasks.max}
        currentPage={this.props.dailyTasks.currentPage}
        totalPages={this.props.dailyTasks.totalPages}
        fetchCallback=""
        numItems={this.props.dailyTasks.numItems}
      />
    ) : (
      ""
    );

    if (dailyTasks) {
      dailyTasks.map((dailyTask, key) => {
        if (dailyTask.date === currentDate) {
          this.state.isCurrentDate = true;
        }
      });
    }
    const addDailyTaskBtn = (
      <Button
        size="sm"
        disabled={this.state.isCurrentDate}
        onClick={() => {
          this.handleCreate();
          this.props.resetDailyTasks();
          // this.props.fetchDailyTasks();
          // this.setState({ isCurrentDate: true });
        }}
      >
        Add Daily Task
      </Button>
    );
    return (
      <React.Fragment>
        <PageTitle pageName="Daily Tasks" actionButton={addDailyTaskBtn} />
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="float-right mt-3">{listPagination}</div>
          </Col>
        </Row>
        <Row>
          <Col>{this.renderDailyTasks()}</Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="float-right mt-3">{listPagination}</div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  dailyTasks: state.dailyTasks,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDailyTasks: () => dispatch(fetchDailyTasks()),
    createDailyTask: () => dispatch(createDailyTask()),
    resetDailyTasks: () => dispatch(resetDailyTasks()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DailyTasks)
);
